import {CSSDimension, getSize, Integer} from 'platform/foundation';

import {MAX_EMAIL_WIDTH} from '../constants/MAX_EMAIL_WIDTH';
import {ThreadEmailSize} from '../types/ThreadEmailSize';

const SPACING_STEP = 4; // px per platform spacing unit
const MIN_EMAIL_WIDTH = 440; // the white window never shrinks below this — narrow emails fill it
const CARD_CHROME = 48; // card + window horizontal padding so the card hugs the email
const MIN_CARD_WIDTH_UNITS = ((MIN_EMAIL_WIDTH + CARD_CHROME) / SPACING_STEP) as Integer;

// Card width ceiling: 85% of the thread panel, but never below the email's minimum card width (so a
// narrow panel can't squeeze the email body under its designed minimum) and never past the panel
// edge. In panels wider than the email minimum this resolves to 85%; in cramped panels it fills 100%.
const CARD_MAX_WIDTH: CSSDimension = `min(100%, max(85%, ${getSize(MIN_CARD_WIDTH_UNITS)}))`;

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export interface ThreadEmailLayout {
  cardWidthUnits: Integer;
  cardMaxWidth: CSSDimension;
}

// Emails always render at their full measured height; only the card WIDTH is derived here.
export function getThreadEmailLayout(size: ThreadEmailSize | null): ThreadEmailLayout {
  const targetWidth = clamp(size?.width ?? MAX_EMAIL_WIDTH, MIN_EMAIL_WIDTH, MAX_EMAIL_WIDTH);

  return {
    cardWidthUnits: Math.round((targetWidth + CARD_CHROME) / SPACING_STEP) as Integer,
    cardMaxWidth: CARD_MAX_WIDTH,
  };
}
